import { useState } from 'react';
import "./CreditCardForm.scss";
import { CreditCard, ShieldCheck  } from 'lucide-react';

export default function CreditCardForm({ onSubmit, onCancel }) {
    const [form, setForm] = useState({
        holderName: '',
        number: '',
        expiryMonth: '',
        expiryYear: '', 
        ccv: '',
        postalCode: '',
        addressNumber: '',
        addressComplement: ''
    });
    const [saveCard, setSaveCard] = useState(true);
    const [localError, setLocalError] = useState('');

    const handleChange = (field) => (e) => {
        setForm((prev) => ({ ...prev, [field]: e.target.value }));
    };

    const validate = () => {
        if (form.number.replace(/\D/g, '').length < 13) return 'Número do cartão inválido.';
        if (!/^\d{2}$/.test(form.expiryMonth)) return 'Mês de validade inválido.';
        if (!/^\d{4}$/.test(form.expiryYear)) return 'Ano de validade inválido (formato AAAA).';
        if (!/^\d{3,4}$/.test(form.ccv)) return 'CVV inválido.';
        if (!form.holderName.trim()) return 'Informe o nome impresso no cartão.';
        if (!form.postalCode.trim()) return 'Informe o CEP do titular.';
        if (!form.addressNumber.trim()) return 'Informe o número do endereço do titular.';
        return null;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const error = validate();
        if (error) {
            setLocalError(error);
            return;
        }

        setLocalError('');
        onSubmit({
            card: {
                holderName: form.holderName.trim(),
                number: form.number.replace(/\D/g, ''),
                expiryMonth: form.expiryMonth,
                expiryYear: form.expiryYear,
                ccv: form.ccv,
                postalCode: form.postalCode.replace(/\D/g, ''),
                addressNumber: form.addressNumber.trim(),
                addressComplement: form.addressComplement.trim() || null
            },
            saveCard
        });
    };

    return (
        <form className="cc-form" onSubmit={handleSubmit}>
            {localError && <div className="cc-error">{localError}</div>}

            <div className="cc-form-title">
                <CreditCard size={16} />
                Dados do novo cartão
            </div>
            <p className="cc-security-note">
                <ShieldCheck size={14} />
                Seus dados são enviados direto para a Asaas de forma segura — não guardamos o número nem o CVV do cartão.
            </p>
            <label>
                Nome impresso no cartão
                <input value={form.holderName} onChange={handleChange('holderName')} placeholder="Como está no cartão" />
            </label>

            <label>
                Número do cartão
                <input value={form.number} onChange={handleChange('number')} placeholder="0000 0000 0000 0000" inputMode="numeric" />
            </label>

            <div className="cc-form-row">
                <label>
                    Mês
                    <input value={form.expiryMonth} onChange={handleChange('expiryMonth')} placeholder="MM" maxLength={2} inputMode="numeric" />
                </label>
                <label>
                    Ano
                    <input value={form.expiryYear} onChange={handleChange('expiryYear')} placeholder="AAAA" maxLength={4} inputMode="numeric" />
                </label>
                <label>
                    CVV
                    <input value={form.ccv} onChange={handleChange('ccv')} placeholder="123" maxLength={4} inputMode="numeric" />
                </label>
            </div>

            <div className="cc-form-row">
                <label>
                    CEP do titular
                    <input value={form.postalCode} onChange={handleChange('postalCode')} placeholder="00000-000" inputMode="numeric" />
                </label>
                <label>
                    Número
                    <input value={form.addressNumber} onChange={handleChange('addressNumber')} placeholder="Nº" />
                </label>
            </div>

            <label className="cc-checkbox">
                <input type="checkbox" checked={saveCard} onChange={(e) => setSaveCard(e.target.checked)} />
                Salvar este cartão para as próximas recargas
            </label>

            <div className="cc-form-actions">
                {onCancel && (
                    <button type="button" className="cc-btn cc-btn--secondary" onClick={onCancel}>
                        Voltar
                    </button>
                )}
                <button type="submit" className="cc-btn cc-btn--primary">
                    Confirmar e pagar
                </button>
            </div>
        </form>
    );
}